import gql from 'graphql-tag'

export const main = gql`
	fragment productGroupMain on ProductGroup {
		id
		name
		code
		groupId
	}
`
